import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeVendors = gql`
  type Vendor {
    id: ID!
    title: String
    status: String
  }

  type Vendors {
    limit: Int
    offset: Int
    count: Int
    total: Int

    items: [Vendor]
  }

  type Query {
    vendor(id: ID!, lang: String = "", cdn: Boolean = true): Vendor

    vendors(
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort
      sortWithinLimits: Boolean = false
      lang: String = ""
      cdn: Boolean = true
    ): Vendors
  }
`

export { typeVendors }

export default typeVendors
